import PropTypes from 'prop-types';
import { Card, Column, Typography } from '@tempmee/react';
import { UNASSIGNED_OPTION_VALUE } from '../../../../../constants/unassigned';
import { formatPersonName } from '../../../../../utils/String';
import styles from './OfficeRamCard.module.scss';

/**
 * The office profile's RAM (metro) field, read-only.
 *
 * Shows the office's assigned metro by name, or "Unassigned". A stored id the
 * list cannot resolve is shown as "Unrecognized metro" with the id rather than
 * as "Unassigned": it is an assignment the list does not know about, not the
 * absence of one.
 */
export const OfficeRamCard = ({ ramId, ramUsers }) => {
  const isUnassigned = !ramId || ramId === UNASSIGNED_OPTION_VALUE;
  const metro = isUnassigned ? null : ramUsers?.find((item) => item.id === ramId);

  return (
    <Card outline className={styles.card}>
      <Column p={4} gap={1} align="center">
        <Typography variant="h5" as="h3" bold textAlign="center">
          RAM
        </Typography>
        {isUnassigned && <Typography textAlign="center">Unassigned</Typography>}
        {metro && <Typography textAlign="center">{formatPersonName(metro)}</Typography>}
        {!isUnassigned && !metro && (
          <>
            <Typography textAlign="center">Unrecognized metro</Typography>
            <Typography variant="caption" textAlign="center">
              {ramId}
            </Typography>
          </>
        )}
      </Column>
    </Card>
  );
};

OfficeRamCard.propTypes = {
  /** The office's stored `ram`: a metro id, `'unassigned'`, or null. */
  ramId: PropTypes.string,
  /** `state.users.ramUsers`: metros in the store's person shape. */
  ramUsers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      first_name: PropTypes.string,
      last_name: PropTypes.string,
    }),
  ),
};

OfficeRamCard.defaultProps = {
  ramId: null,
  ramUsers: [],
};
